import { Globe, User, Clock, FileText } from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * MockMetadataPanel
 * メタデータサイドバーのモックアップ（ダーク固定）
 * Desktop App Showcaseセクションで使用
 */
export function MockMetadataPanel({ className }: { className?: string }) {
  return (
    <div className={cn('border-l border-white/[0.06] bg-white/[0.02] p-5', className)}>
      {/* Title */}
      <h4 className="text-[13px] font-semibold text-white/90 mb-4">Photo Details</h4>

      {/* VRChat Info */}
      <div className="mb-4 pb-4 border-b border-white/[0.06]">
        <div className="text-[10px] font-semibold text-white/35 uppercase tracking-wider mb-2">
          VRChat Info
        </div>
        <div className="flex items-center gap-2 text-xs text-white/70 mb-1.5">
          <Globe className="w-3.5 h-3.5 text-white/35" strokeWidth={2} />
          <span>Sunset Rooftop</span>
        </div>
        <div className="flex items-center gap-2 text-xs text-white/70 mb-1.5">
          <User className="w-3.5 h-3.5 text-white/35" strokeWidth={2} />
          <span>yosh1ken</span>
        </div>
        <div className="flex items-center gap-2 text-xs text-white/70">
          <Clock className="w-3.5 h-3.5 text-white/35" strokeWidth={2} />
          <span>2026-01-15 22:31</span>
        </div>
      </div>

      {/* Players */}
      <div className="mb-4 pb-4 border-b border-white/[0.06]">
        <div className="text-[10px] font-semibold text-white/35 uppercase tracking-wider mb-2">
          Players
        </div>
        <div className="flex flex-wrap gap-1">
          <span className="flex items-center gap-1 text-[10px] px-2 py-1 bg-white/[0.06] border border-white/[0.08] rounded-full text-white/70">
            <span className="w-1.5 h-1.5 rounded-full" style={{ background: 'hsl(200,60%,50%)' }} />
            Player_A
          </span>
          <span className="flex items-center gap-1 text-[10px] px-2 py-1 bg-white/[0.06] border border-white/[0.08] rounded-full text-white/70">
            <span className="w-1.5 h-1.5 rounded-full" style={{ background: 'hsl(340,60%,50%)' }} />
            Player_B
          </span>
          <span className="flex items-center gap-1 text-[10px] px-2 py-1 bg-white/[0.06] border border-white/[0.08] rounded-full text-white/70">
            <span className="w-1.5 h-1.5 rounded-full" style={{ background: 'hsl(120,50%,45%)' }} />
            Player_C
          </span>
        </div>
      </div>

      {/* File Info */}
      <div>
        <div className="text-[10px] font-semibold text-white/35 uppercase tracking-wider mb-2">
          File
        </div>
        <div className="flex items-center gap-2 text-xs text-white/70 mb-1">
          <FileText className="w-3.5 h-3.5 text-white/35" strokeWidth={2} />
          <span className="text-[11px]">VRChat_2026-01-15_223145.png</span>
        </div>
        <div className="text-[11px] text-white/35">3840 x 2160 / 8.2 MB</div>
      </div>
    </div>
  );
}
